<div class="chart-line">
    <canvas #chart></canvas>
</div>
